import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";
import logo from "../assets/wes-logo.webp";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const location = useLocation();

  /* Scroll behavior */
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrolled(currentScrollY > 50);

      // Hide only on desktop
      if (window.innerWidth > 960) {
        if (currentScrollY > lastScrollY && currentScrollY > 80) {
          setShowHeader(false);
        } else {
          setShowHeader(true);
        }
      } else {
        setShowHeader(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  /* Close menu on route change */
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  /* Prevent body scroll when menu open */
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  /* ✅ UPDATED SEO NAV LINKS */
  const navLinks = [
    { to: "/", label: "Home" },

    { to: "/modular-ot-services", label: "Modular OT Services" },

    { to: "/modular-ot-gallery", label: "OT Gallery" },

    { to: "/hospital-ot-projects", label: "Projects" },
    
    { to: "/customer-reviews", label: "Reviews" },

    { to: "/contact-modular-ot", label: "Get Quote", cta: true },
  ];

  return (
    <>
      <header
        className={`header${scrolled ? " scrolled" : ""}${
          showHeader ? " show" : " hide"
        }`}
      >
        {/* Logo */}
        <Link to="/" className="logo" aria-label="WEMS Home">
          <img src={logo} alt="Wellness Electro Medical Systems Logo" />
        </Link>

        {/* Navigation */}
        <nav id="main-nav" className={`nav${menuOpen ? " open" : ""}`}>
          {navLinks.map(({ to, label, cta }) => (
            <Link
              key={to}
              to={to}
              className={[
                cta ? "nav-cta" : "",
                location.pathname === to ? "active" : "",
              ]
                .filter(Boolean)
                .join(" ")}
              onClick={() => setMenuOpen(false)}
            >
              {label}
            </Link>
          ))}
        </nav>

        {/* Hamburger */}
        <button
          className={`hamburger${menuOpen ? " active" : ""}`}
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </header>

      {/* Backdrop */}
      <div
        className={`nav-backdrop${menuOpen ? " visible" : ""}`}
        onClick={() => setMenuOpen(false)}
      />
    </>
  );
}

export default Header;
